import AuthService from "./auth.service";
import http from "./http-common";

const token = AuthService.getToken();

const getAllLocations = () => {
  return http.get("/User/GetAllLocation", {
    headers: { Authorization: "Bearer " + token },
  });
};

const getEmpBasicInfoByLoc = (data) => {
  return http.post("/User/GetEmpBasicInfoByLoc", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getEmpDetailsByID = (data) => {
  return http.post("/User/GetEmpDetailsByID", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getEmpDetailsForUpd = (data) => {
  return http.post("/User/GetEmpDetailsForUpd", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const updateEmpData = (data) => {
  return http.post("/User/UpdateEmpData", data, {
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "multipart/form-data",
    },
  });
};

const getAlldepts = () => {
  return http.get("/User/GetAlldepts", {
    headers: { Authorization: "Bearer " + token },
  });
};

const insertUser = (data) => {
  return http.post("/User/InsertUser", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getLeaveOverViewReport = (data) => {
  return http.post("/Dashboard/GetLeaveOverViewReport", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const GetRmList = () => {
  return http.get("/User/GetRmList", {
    headers: { Authorization: "Bearer " + token },
  });
};

const GetEmpList = () => {
  return http.get("/User/GetEmpList", {
    headers: { Authorization: "Bearer " + token },
  });
};




const CommonService = {
  getAllLocations,
  getEmpBasicInfoByLoc,
  getEmpDetailsByID,
  getEmpDetailsForUpd,
  updateEmpData,
  getAlldepts,
  insertUser,
  getLeaveOverViewReport,
  GetRmList,
  GetEmpList
};

export default CommonService;
